






















































import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import dayjs from "dayjs";

@Component
export default class AppDatepicker extends Vue {
  @Prop() name: string;
  @Prop() placeholder: string;
  @Prop() label: string;
  @Prop() value: string;
  @Prop() error: string;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: "HH:mm" }) format: string;
  labelClass: string = "block text-gray-600 text-xs font-bold px-3";

  btnToggle: boolean = false;
  date: any = null;

  get errorMessage(): string | null {
    return this.error ? this.error : null;
  }

  mounted() {
    this.date = dayjs().toDate();
  }

  @Emit("input")
  update(e: any) {
    return this.date;
  }

  get valueFormatted() {
    if (this.value) {
      return dayjs(this.value).format(this.format);
    }
    return "-";
  }

  @Watch("value")
  async watchValue(val: string, oldVal: string) {
    this.date = val;
  }

  @Emit("onEditable")
  async onEditable() {}
}
